import React, { useState } from 'react';
import { Field } from '@atlaskit/form';
import TextField from '@atlaskit/textfield';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import { catalog } from '@atlassiansox/metal-client';
import { metalClient } from '../../../../metrics';
import { useDevopsState } from '../../hook';
import { messages } from '../../messages';
import { ErrorMessage, FieldWrapper } from '../styled';
import {
  useAppDispatch,
  useAppSelector,
  updateN2NDeferredPasswordFieldProgressFullName,
  updateN2NDeferredPasswordFieldValidationFullName
} from '../../../../redux';

export function InputName() {
  const { intl } = useDevopsState();
  const dispatch = useAppDispatch();

  const validationStateFullName = useAppSelector(
    ({ n2nDeferredPasswordFieldValidation: { fullName } }) => fullName
  );

  const [hasFocusFullName, setHasFocusFullName] = useState(false);
  const nonValidNamePattern =
    /((http(s)?|ftp|callto|mailto|skype|magnet):)|www\.|:\/\/|@|\$|^\s+$/i;

  function validateFullName(value: string) {
    if (!hasFocusFullName) {
      return undefined;
    }
    const isValid = !nonValidNamePattern.exec(value) && value.length <= 255;
    if (value.length === 0) {
      dispatch(updateN2NDeferredPasswordFieldValidationFullName(undefined));
      return undefined;
    }
    if (isValid) {
      dispatch(updateN2NDeferredPasswordFieldValidationFullName('success'));
      dispatch(updateN2NDeferredPasswordFieldProgressFullName(true));
      return undefined;
    } else {
      dispatch(updateN2NDeferredPasswordFieldValidationFullName('error'));
      metalClient.error.submit({
        name: catalog.error.INPUT,
        page: 'sign-up-layout-devops',
        component: 'devops-input-fullname'
      });
      return 'Invalid Name';
    }
  }

  return (
    <FieldWrapper>
      <Field
        name="fullName"
        defaultValue=""
        label={intl.formatMessage(messages.inputLabelFullName)}
        validate={validateFullName}
        isRequired
        isDisabled={false}
      >
        {({ fieldProps }: any) => {
          return (
            <FieldWrapper
              validationState={validationStateFullName}
              isDisabled={fieldProps.isDisabled}
            >
              <TextField
                {...fieldProps}
                data-testid="devops-input-fullname"
                onFocus={() => setHasFocusFullName(true)}
                onBlur={() => setHasFocusFullName(false)}
              />
            </FieldWrapper>
          );
        }}
      </Field>

      {validationStateFullName === 'error' && (
        <ErrorMessage>
          <SanitizedFormattedHtmlMessage {...messages.errorName} />
        </ErrorMessage>
      )}
    </FieldWrapper>
  );
}
